import { useCallback } from "react";
import {
  getBezierPath,
  getSmoothStepPath,
  getStraightPath,
  useStore,
  MarkerType,
} from "reactflow";

import { getEdgeParams } from "./utils.js";

import {
  getEdgeDeleteButtonVisibility,
  getEdgeDeleteButtonSize,
  getDeleteMode,
  getEdgeType,
} from "./UserSettings";
import { Button } from "antd";
import { DeleteOutlined } from "@ant-design/icons";

let edgeDeleteButtonSize = getEdgeDeleteButtonSize();
let isEdgeDeleteButtonVisible = getEdgeDeleteButtonVisibility();

function FloatingEdge({
  id,
  source,
  target,
  markerEnd = { type: MarkerType.ArrowClosed, fill: "black" },
  style,
  data,
}) {
  const sourceNode = useStore(
    useCallback((store) => store.nodeInternals.get(source), [source])
  );
  const targetNode = useStore(
    useCallback((store) => store.nodeInternals.get(target), [target])
  );

  if (!sourceNode || !targetNode) {
    return null;
  }

  const { sx, sy, tx, ty, sourcePos, targetPos } = getEdgeParams(
    sourceNode,
    targetNode
  );

  const [curveEdgePath] = getBezierPath({
    sourceX: sx,
    sourceY: sy,
    sourcePosition: sourcePos,
    targetPosition: targetPos,
    targetX: tx,
    targetY: ty,
  });
  const [straightEdgePath] = getStraightPath({
    sourceX: sx,
    sourceY: sy,
    sourcePosition: sourcePos,
    targetPosition: targetPos,
    targetX: tx,
    targetY: ty,
  });
  const [stepEdgePath] = getSmoothStepPath({
    sourceX: sx,
    sourceY: sy,
    sourcePosition: sourcePos,
    targetPosition: targetPos,
    targetX: tx,
    targetY: ty,
  });

  let foreignObject = <></>;
  if (getDeleteMode()) {
    foreignObject = (
      <foreignObject
        name="deletebutton"
        width={edgeDeleteButtonSize}
        height={edgeDeleteButtonSize}
        x={(sx + tx - edgeDeleteButtonSize) / 2}
        y={(sy + ty - edgeDeleteButtonSize) / 2}
        className="edgebutton-foreignobject"
      >
        <body>
          <Button
            icon={
              <DeleteOutlined
                style={{ fontSize: "1.15em", paddingTop: "0.15em" }}
              />
            }
            className="aaa"
            size="small"
            type="primary"
            danger={true}
            shape="circle"
            onClick={() => data.funcs.delEdge(id)}
          ></Button>
        </body>
      </foreignObject>
    );
  }

  let path = (
    <>
      <path
        id={id}
        className="react-flow__edge-path"
        d={
          getEdgeType() === "default"
            ? curveEdgePath
            : getEdgeType() === "straight"
            ? straightEdgePath
            : stepEdgePath
        }
        markerEnd={markerEnd}
        style={style}
      />
    </>
  );

  if (!isEdgeDeleteButtonVisible) {
    return path;
  } else {
    return [path, foreignObject]; // JSX elements must be wrapped in an array or fragment when returning multiple elements.
  }
}

export default FloatingEdge;
